import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Person } from '../api/models/Person';

type State = {
  list: Person[];
};

export const peopleSlice = createSlice({
  name: 'people',
  initialState: {
    list: [],
  } as State,
  reducers: {
    receivedList: (state, action: PayloadAction<{ persons: Person[] }>) => {
      state.list = action.payload.persons;
    },
  },
});
